import { Add, Edit } from "@carbon/icons-react";
import { useQuery } from "@tanstack/react-query";
import { createFileRoute } from "@tanstack/react-router";
import { useState } from "react";

import { listFormsQueryOptions } from "@/api/listForms";
import { FormEditDialog } from "@/components/admin/formEditDialog";
import { Button } from "@/components/input/button";
import { Form } from "@/schemas/form";

export const Route = createFileRoute("/dashboard/_authenticated/admin/forms")({
  component: RouteComponent,
  staticData: {
    breadcrumb: ["Forms"],
  },
});

function RouteComponent() {
  const { data: forms, isLoading } = useQuery(listFormsQueryOptions());
  const [editingForm, setEditingForm] = useState<Form | undefined>();
  const [isCreating, setIsCreating] = useState(false);

  return (
    <div className="flex flex-col gap-6">
      <div className="flex items-center justify-between">
        <h1 className="text-page-title">Forms</h1>
        <Button intent="primary" onClick={() => setIsCreating(true)} size="sm">
          <Add size={16} />
          Add form
        </Button>
      </div>

      {isLoading ? (
        <div className="text-body2 text-neutral-600">Loading...</div>
      ) : (
        <div className="flex flex-col gap-4">
          {forms?.map((form) => (
            <div
              className="
                flex flex-col gap-2 rounded-lg border border-primary-200 p-6
              "
              key={form.id}
            >
              <div className="flex items-start justify-between gap-4">
                <h3 className="text-h3">{form.name}</h3>
                <Button
                  onClick={() => setEditingForm(form)}
                  size="sm"
                  type="button"
                >
                  <Edit size={16} />
                  Edit
                </Button>
              </div>
              <p className="text-body2 text-neutral-600">
                {form.topics.map((topic) => topic.category).join(", ")}
              </p>
            </div>
          ))}
        </div>
      )}

      <FormEditDialog onOpenChange={setIsCreating} open={isCreating} />
      <FormEditDialog
        onOpenChange={(open) => {
          if (!open) {
            setEditingForm(undefined);
          }
        }}
        open={editingForm !== undefined}
        form={editingForm}
      />
    </div>
  );
}
